/* squiq-cart-validation.js
   SQUIQ — aus assets/cart-drawer.js herausgeloest (D1-Migration Be Yours 9.5.1, TSK-1740).
   Zweck: blockiert den Checkout, solange Campingbox-Hinweis (#campingbox_notice) oder
          Haendler-AGB (#haendler_agb_accept) nicht bestaetigt sind. Submit-Listener in der
          Capture-Phase, damit Theme-Handler nicht vorher durchrutschen.
   Grund der Auslagerung: ein Theme-Update setzt Vanilla-Dateien byte-genau zurueck.
   Code in einer eigenen Datei ueberlebt jedes Update; Code IN einer Theme-Datei nicht.
   Eingebunden in layout/theme.liquid. Inhalt unveraendert uebernommen. */
(function () {
  function blockCheckoutIfNeeded(event) {
    const form = event.target;
    if (!form || form.tagName !== 'FORM') return;

    const submitter = event.submitter;
    if (!submitter) return;

    // Nur Checkout-Submit blockieren (nicht "update", nicht qty-change)
    const isCheckout =
      submitter.name === 'checkout' ||
      submitter.getAttribute('name') === 'checkout' ||
      submitter.matches('[name="checkout"]');

    if (!isCheckout) return;

    const checkbox = form.querySelector('#campingbox_notice');
    const errorEl = form.querySelector('#campingbox_notice_error');

    const dealerCheckbox = form.querySelector('#haendler_agb_accept');
    const dealerErrorEl = form.querySelector('#haendler_agb_error');

    let hasError = false;
    let firstInvalidElement = null;

    if (checkbox && !checkbox.checked) {
      hasError = true;
      if (!firstInvalidElement) firstInvalidElement = checkbox;
      if (errorEl) errorEl.style.display = 'block';
    } else {
      if (errorEl) errorEl.style.display = 'none';
    }

    if (dealerCheckbox && !dealerCheckbox.checked) {
      hasError = true;
      if (!firstInvalidElement) firstInvalidElement = dealerCheckbox;
      if (dealerErrorEl) dealerErrorEl.style.display = 'block';
    } else {
      if (dealerErrorEl) dealerErrorEl.style.display = 'none';
    }

    if (hasError) {
      event.preventDefault();
      event.stopPropagation();

      try {
        firstInvalidElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } catch (e) {}

      return;
    }
  }

  // Capture-Phase, damit Theme-Handler nicht vorher "durchrutschen"
  document.addEventListener('submit', blockCheckoutIfNeeded, true);

  // Fehler ausblenden, sobald angehakt
  document.addEventListener('change', function (e) {
    if (e.target && e.target.id === 'campingbox_notice') {
      const form = e.target.closest('form');
      const errorEl = form ? form.querySelector('#campingbox_notice_error') : null;
      if (errorEl) errorEl.style.display = e.target.checked ? 'none' : 'block';
    }

    if (e.target && e.target.id === 'haendler_agb_accept') {
      const form = e.target.closest('form');
      const errorEl = form ? form.querySelector('#haendler_agb_error') : null;
      if (errorEl) errorEl.style.display = e.target.checked ? 'none' : 'block';
    }
  }, true);
})();
